
import { Shield, Building, Wrench, Heart, MessageCircle } from "lucide-react";
import PropertyInquiryFormHorizontal from "./PropertyInquiryFormHorizontal";
import { CONTACT } from "@/constants/config";
import { trackEvent, EVENTS } from "@/utils/analytics-events";

const CallToAction = () => {
  return (
    <section className="section-padding theme-section relative overflow-hidden bg-white">
      <div className="container mx-auto px-4 md:px-6">
        <div className="max-w-4xl mx-auto">
          <div className="rounded-2xl overflow-hidden shadow-lg group relative bg-white">
            <div className="absolute inset-0 overflow-hidden">
              <div className="absolute inset-0 bg-gradient-to-br from-[var(--theme-primary)]/5 to-transparent opacity-60"></div>
            </div>
            
            <div className="relative z-10 p-8 md:p-10">
              <div className="text-center mb-6">
                <h2 className="text-3xl md:text-4xl font-bold theme-primary-text mb-4">Sẵn Sàng Tối Đa Hóa Thu Nhập Cho Thuê?</h2>
                <p className="text-xl text-foreground/80 max-w-2xl mx-auto">
                  Tham gia cùng hàng chục chủ nhà đã tin tưởng bàn giao trải nghiệm cho thuê của họ.
                </p>
                <div className="section-divider mx-auto mt-6"></div>
              </div>
              
              <div className="grid grid-cols-1 md:grid-cols-4 gap-6 mb-8">
                <BenefitCard
                  icon={Shield}
                  title="Minh Bạch Tài Chính"
                  description="Báo cáo tài chính chi tiết, thu tiền hộ chuyên nghiệp"
                />
                <BenefitCard 
                  icon={Building}
                  title="Giá Trị Bất Động Sản"
                  description="Bảo trì thường xuyên và làm mới hàng năm"
                />
                <BenefitCard 
                  icon={Wrench}
                  title="Quản Lý Chuyên Nghiệp"
                  description="Sàng lọc khách thuê cao cấp và chăm sóc bất động sản"
                />
                <BenefitCard 
                  icon={Heart}
                  title="An Tâm Tuyệt Đối"
                  description="Không cần can thiệp với hỗ trợ khẩn cấp 24/7"
                />
              </div>
              
              <div className="mt-8 space-y-6 max-w-3xl mx-auto">
                <div className="bg-muted/40 p-6 rounded-xl border border-border shadow-sm">
                  <div className="flex flex-col gap-4">
                    <PropertyInquiryFormHorizontal ctaLabel="Nhận Báo Giá Miễn Phí" />
                    
                    <div className="flex flex-col sm:flex-row items-center justify-between gap-4 pt-4 border-t border-border/60">
                      <p className="text-xs text-foreground/60 text-center sm:text-left">
                        ⏱️ Chỉ mất 2 phút • Phản hồi trong 24–48 giờ • Đánh giá bất động sản miễn phí.
                      </p>
                      <button 
                        onClick={() => {
                          trackEvent(EVENTS.ZALO_CLICK, { location: 'cta_section' });
                          const message = "Xin chào! Tôi muốn tìm hiểu dịch vụ quản lý căn hộ chuyên nghiệp của Propico cho căn hộ của tôi.";
                          const encodedMessage = encodeURIComponent(message);
                          window.open(`https://zalo.me/${CONTACT.ZALO}?text=${encodedMessage}`, '_blank');
                        }}
                        className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-5 py-2.5 text-sm font-semibold rounded-lg bg-[#0068FF] hover:bg-[#0052CC] text-white transition-colors shadow-sm"
                      >
                        <MessageCircle size={16} />
                        Nhận tư vấn nhanh qua Zalo
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      {/* Background Elements */}
      <div className="absolute -top-20 -left-20 w-80 h-80 theme-primary-bg opacity-5 rounded-full blur-3xl -z-10"></div>
      <div className="absolute bottom-10 right-10 w-64 h-64 theme-accent-bg opacity-5 rounded-full blur-2xl -z-10"></div>
    </section>
  );
};

const BenefitCard = ({
  icon: Icon,
  title,
  description,
}: {
  icon: React.ElementType;
  title: string;
  description: string;
}) => {
  return (
    <div className="p-5 rounded-xl bg-white border border-gray-100 shadow-sm hover:shadow-md transition-all duration-300 hover:border-[var(--theme-primary)]/20">
      <div className="flex items-center space-x-3 mb-3">
        <div className="w-10 h-10 rounded-lg theme-accent-light-bg flex items-center justify-center">
          <Icon size={20} className="theme-accent-text" />
        </div>
        <h3 className="text-lg font-semibold theme-primary-text">{title}</h3>
      </div>
      <p className="text-sm text-foreground/70">{description}</p>
    </div>
  );
};

export default CallToAction;
